import messages from './cmsDuplicate.json' with { type: 'json' };

export const cmsDuplicateEn: Readonly<typeof messages> = messages;
